export { SignatureCaptureModule } from './signature-capture.module';
export { SignatureCaptureComponent } from './signature-capture.component';
